<app-header-latest></app-header-latest>
<div class="careers-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow">🌟 JOIN THE TEAM</div>
      <h1>Build the Future<br>of <span style="color:#FCD34D;">Work, with Us</span></h1>
      <p>We're a team of engineers, designers, and HR nerds on a mission to make work better for everyone. Come help us build tools that actually matter.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="#open-roles" class="btn btn-white">See Open Roles</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Our Culture Deck</a>
      </div>
    </div>
    <div>
      <div class="perks-widget">
        <div class="perks-widget-title">Why People Love Working Here</div>
        <div class="perks-list">
          <div class="perk-item">🌍 Remote-First<span>Work from anywhere</span></div>
          <div class="perk-item">🏥 Full Benefits<span>Medical, dental, vision</span></div>
          <div class="perk-item">📚 $600 L&amp;D Budget<span>Annual learning allowance</span></div>
          <div class="perk-item">🏖️ Unlimited PTO<span>Take real time off</span></div>
          <div class="perk-item">💰 Equity<span>Real ownership stake</span></div>
          <div class="perk-item">🖥️ $1,500 Setup<span>Home office budget</span></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- VALUES -->
<section class="values-strip">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">💡 Our Values</span>
      <h2 class="sec-h2">What We Actually<br><span class="gradient-text">Believe In</span></h2>
      <p class="sec-sub">Not just words on a wall — principles that guide how we hire, build, and treat each other every single day.</p>
    </div>
    <div class="values-strip-grid">
      <div class="value-tile">
        <div class="value-tile__icon">🔍</div>
        <div class="value-tile__title">Radical Transparency</div>
        <div class="value-tile__desc">All company metrics, decisions, and strategy are shared openly — no information hoarding.</div>
      </div>
      <div class="value-tile">
        <div class="value-tile__icon">🚀</div>
        <div class="value-tile__title">Bias Toward Action</div>
        <div class="value-tile__desc">We move fast, learn from failures, and iterate. Waiting for perfect is the enemy of shipped.</div>
      </div>
      <div class="value-tile">
        <div class="value-tile__icon">🤝</div>
        <div class="value-tile__title">Empathy First</div>
        <div class="value-tile__desc">For customers, teammates, and candidates — we lead with care and assume positive intent.</div>
      </div>
      <div class="value-tile">
        <div class="value-tile__icon">📐</div>
        <div class="value-tile__title">High Standards</div>
        <div class="value-tile__desc">We hold each other to excellence — in code, design, writing, and the experience we build.</div>
      </div>
    </div>
  </div>
</section>

<!-- OPEN ROLES -->
<section class="open-roles" id="open-roles">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📋 Open Positions</span>
      <h2 class="sec-h2">Find Your Role<br><span class="gradient-text">at NeoHRMZ</span></h2>
      <p class="sec-sub">We're hiring across engineering, design, product, and go-to-market. Every role is remote-eligible.</p>
    </div>
    <div class="roles-grid">
      <div class="role-card">
        <div class="role-card__left">
          <div class="role-card__icon">⚙️</div>
          <div>
            <div class="role-card__title">Senior Backend Engineer — Payroll Infrastructure</div>
            <div class="role-card__tags">
              <span class="role-card__tag">Remote</span>
              <span class="role-card__tag">Engineering</span>
              <span class="role-card__tag">Full-Time</span>
            </div>
          </div>
        </div>
        <a href="#" class="btn btn-outline" style="white-space:nowrap;flex-shrink:0;">Apply →</a>
      </div>
      <div class="role-card">
        <div class="role-card__left">
          <div class="role-card__icon">🎨</div>
          <div>
            <div class="role-card__title">Product Designer — Employee Experience</div>
            <div class="role-card__tags">
              <span class="role-card__tag">Remote</span>
              <span class="role-card__tag">Design</span>
              <span class="role-card__tag">Full-Time</span>
            </div>
          </div>
        </div>
        <a href="#" class="btn btn-outline" style="white-space:nowrap;flex-shrink:0;">Apply →</a>
      </div>
      <div class="role-card">
        <div class="role-card__left">
          <div class="role-card__icon">📣</div>
          <div>
            <div class="role-card__title">Content Marketing Manager — HR Vertical</div>
            <div class="role-card__tags">
              <span class="role-card__tag">Remote</span>
              <span class="role-card__tag">Marketing</span>
              <span class="role-card__tag">Full-Time</span>
            </div>
          </div>
        </div>
        <a href="#" class="btn btn-outline" style="white-space:nowrap;flex-shrink:0;">Apply →</a>
      </div>
      <div class="role-card">
        <div class="role-card__left">
          <div class="role-card__icon">🤝</div>
          <div>
            <div class="role-card__title">Enterprise Account Executive — APAC</div>
            <div class="role-card__tags">
              <span class="role-card__tag">Hybrid</span>
              <span class="role-card__tag">Sales</span>
              <span class="role-card__tag">Full-Time</span>
            </div>
          </div>
        </div>
        <a href="#" class="btn btn-outline" style="white-space:nowrap;flex-shrink:0;">Apply →</a>
      </div>
      <div class="role-card">
        <div class="role-card__left">
          <div class="role-card__icon">🔬</div>
          <div>
            <div class="role-card__title">ML Engineer — HR Analytics &amp; Predictions</div>
            <div class="role-card__tags">
              <span class="role-card__tag">Remote</span>
              <span class="role-card__tag">AI / ML</span>
              <span class="role-card__tag">Full-Time</span>
            </div>
          </div>
        </div>
        <a href="#" class="btn btn-outline" style="white-space:nowrap;flex-shrink:0;">Apply →</a>
      </div>
      <div class="role-card">
        <div class="role-card__left">
          <div class="role-card__icon">🛡️</div>
          <div>
            <div class="role-card__title">Security Engineer — Compliance &amp; Infra</div>
            <div class="role-card__tags">
              <span class="role-card__tag">Remote</span>
              <span class="role-card__tag">Security</span>
              <span class="role-card__tag">Full-Time</span>
            </div>
          </div>
        </div>
        <a href="#" class="btn btn-outline" style="white-space:nowrap;flex-shrink:0;">Apply →</a>
      </div>
    </div>
  </div>
</section>

<!-- LIFE AT NeoHRMZ -->
<section class="life-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📸 Life at NeoHRMZ</span>
      <h2 class="sec-h2">Real People,<br><span class="gradient-text">Real Moments</span></h2>
      <p class="sec-sub">Retreats, hackathons, team dinners, and the occasional dog on a Zoom call — this is what working here actually looks like.</p>
    </div>
    <div class="life-mosaic">
      <div class="life-tile life-tile--tall" style="background:linear-gradient(135deg,#451a03,#d97706);">
        <div class="life-tile__inner">
          <div class="life-tile__label">Annual Offsite 2024</div>
          <div class="life-tile__sub">Goa, India — 80 team members</div>
        </div>
      </div>
      <div class="life-tile" style="background:linear-gradient(135deg,#1e1b4b,#6366f1);">
        <div class="life-tile__inner">
          <div class="life-tile__label">Hack Week</div>
          <div class="life-tile__sub">3 shipped features, 1 weekend</div>
        </div>
      </div>
      <div class="life-tile" style="background:linear-gradient(135deg,#083344,#0891b2);">
        <div class="life-tile__inner">
          <div class="life-tile__label">Remote Coffee Chats</div>
          <div class="life-tile__sub">Weekly cross-team connects</div>
        </div>
      </div>
      <div class="life-tile" style="background:linear-gradient(135deg,#052e16,#15803d);">
        <div class="life-tile__inner">
          <div class="life-tile__label">Volunteer Day</div>
          <div class="life-tile__sub">Quarterly community give-back</div>
        </div>
      </div>
      <div class="life-tile" style="background:linear-gradient(135deg,#4a0011,#e11d48);">
        <div class="life-tile__inner">
          <div class="life-tile__label">Demo Day</div>
          <div class="life-tile__sub">Everyone ships, everyone presents</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- BENEFITS -->
<section class="benefits-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🎁 Perks &amp; Benefits</span>
      <h2 class="sec-h2">We Take Care<br><span class="gradient-text">of the Whole You</span></h2>
      <p class="sec-sub">Compensation is just the start. We invest in the health, growth, and happiness of every person on the team.</p>
    </div>
    <div class="benefits-grid">
      <div class="benefit-card">
        <div class="benefit-card__icon">🏥</div>
        <div class="benefit-card__title">Comprehensive Health Cover</div>
        <div class="benefit-card__desc">Medical, dental, and vision for you and dependents — fully company-paid on all plans including family coverage.</div>
      </div>
      <div class="benefit-card">
        <div class="benefit-card__icon">📈</div>
        <div class="benefit-card__title">Meaningful Equity</div>
        <div class="benefit-card__desc">Early-stage options with a 4-year vest, 1-year cliff. We want everyone to own a real piece of what we're building together.</div>
      </div>
      <div class="benefit-card">
        <div class="benefit-card__icon">🌍</div>
        <div class="benefit-card__title">Remote-First Culture</div>
        <div class="benefit-card__desc">Work from anywhere — we have teammates in 18 countries. Async-first norms mean no mandatory 9am standups.</div>
      </div>
      <div class="benefit-card">
        <div class="benefit-card__icon">📚</div>
        <div class="benefit-card__title">$600 Learning Budget</div>
        <div class="benefit-card__desc">Courses, books, conferences, certifications — spend it how you learn best with zero approval bureaucracy.</div>
      </div>
      <div class="benefit-card">
        <div class="benefit-card__icon">💻</div>
        <div class="benefit-card__title">$1,500 Home Office Setup</div>
        <div class="benefit-card__desc">Full allowance on day one to build the workspace you need. Laptop, monitor, chair — whatever helps you do your best work.</div>
      </div>
      <div class="benefit-card">
        <div class="benefit-card__icon">🏖️</div>
        <div class="benefit-card__title">Unlimited Paid Time Off</div>
        <div class="benefit-card__desc">Genuinely unlimited. We track output, not hours — and managers are required to take time off themselves to model the culture.</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="careers-cta">
  <div class="container-wrapper">
    <h2 class="careers-cta__h2">Your Next Chapter<br>Starts Here</h2>
    <p class="careers-cta__p">We're growing fast and building something real. If you're passionate about making work better, we'd love to meet you.</p>
    <div class="careers-cta__actions">
      <a href="#open-roles" class="btn btn-white">Browse Open Roles</a>
      <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Reach Out Directly</a>
    </div>
  </div>
</section>

<app-peopleflow-footer></app-peopleflow-footer>